module.exports = __webpack_public_path__ + "dbcc900049b5a2f079906ae1fd34c1b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/covers/order.png
// module id = 638
// module chunks = 4